export { default } from './ClientCardOverflowMenu';
export type { OverflowTab } from './ClientCardOverflowMenu';
